import { WSGENV_APP_ID } from "@/common/js/constant";
import { initSDK, wsgParams } from "@didi/wsgsdk";

// wsgsdk 文档 https://git.xiaojukeji.com/BusinessAccessSecurity/frontend/Web/wsgsdk/blob/master/README.md
initSDK({
  // 必传
  appId: String(WSGENV_APP_ID),
  // test：测试环境；RUS：俄罗斯；AME：美东;SOFI：金融专用；CN：国内环境；G：不明地区时候默认域名；
  env: "SOFI", // 必传
  // 线上加白灰度放量需要，测试环境可不传
  uid: "", // 必传 否则传空字符串
  // v1.1.8 新增
  // 非必传 默认为空；common开启初始化前的内置全量字段采集；默认不填，默认关闭内置字段采集；
  wsgenvType: "common",
  // 非必传 默认为空；single关闭兼容NA端字段采集能力；默认不填，开启自动识别NA环境；
  wsgenvEnv: "single",
  // 非必传 默认为false；默认不开启401 402字段采集；
  isOpenAction: true,
});

// 获取 wsgenv
export const getWsgenv = (url: string) => {
  return new Promise<string>((resolve) => wsgParams({ url }, resolve));
};
